import React, { useEffect, useState } from "react";
import { Col, Container, Row, Tab, Nav } from "react-bootstrap";
import PageTitle from "../ui/PageTitle";
import ToastMsg from "../ui/ToastMsg";
import useApp from "../../utils/useApp";
import { trackNavigationEvent } from "../../utils/analytics";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faBullseye, faClipboardUser, faUserFriends } from "@fortawesome/free-solid-svg-icons";
import useMenuToggle from "../../utils/useMenuToggle";
import BedAssignment from "./BedAssignment";
import BedOccupancy from "./BedOccupancy";
import BedInspection from "./BedInspection";
import CheckIn from "./CheckIn";

const Shelter = () => {
  const { showMenu }: any = useApp();
  const toggleMenu = useMenuToggle();
  const [activeAssign, setActiveAssign] = useState<boolean>(true);
  const [activeOccupancy, setActiveOccupancy] = useState<boolean>(false);
  const [activeInspection, setActiveInspection] = useState<boolean>(false);
  const [activeCheckIn, setActiveCheckIn] = useState<boolean>(false);
  const [orgToSave, setOrgToSave] = useState<boolean>(false);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [toastBody, setToastBody] = useState<string>("");
  const [toastText, setToastText] = useState<string>("");
  //get active tab data states
  const [getAssignmentData, setGetAssignmentData] = useState<boolean>(true);
  const [getOccupancyData, setGetOccupancyData] = useState<boolean>(false);
  const [getInspectionData, setGetInspectionData] = useState<boolean>(false);
  const [getCheckInData, setGetCheckInData] = useState<boolean>(false);
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    setActiveAssign(true);
    setActiveOccupancy(false);
    setActiveInspection(false);
    setActiveCheckIn(false);

    trackNavigationEvent("switch_view", "shelter_bed_assignment");
  }, []);

  const onNavClick = (route: string) => {
    setErrMsg("");
    if (route) {
      trackNavigationEvent("switch_view", "shelter_" + route);
    }

    switch (route) {
      case "bed_assignment":
        setActiveAssign(true);
        setActiveOccupancy(false);
        setActiveInspection(false);
        setActiveCheckIn(false);

        setGetAssignmentData(true);
        setGetOccupancyData(false);
        setGetInspectionData(false);
        setGetCheckInData(false);
        break;
      case "bed_occupancy":
        setActiveAssign(false);
        setActiveOccupancy(true);
        setActiveInspection(false);
        setActiveCheckIn(false);

        setGetAssignmentData(false);
        setGetOccupancyData(true);
        setGetInspectionData(false);
        setGetCheckInData(false);
        break;
      case "bed_inspection":
        setActiveAssign(false);
        setActiveOccupancy(false);
        setActiveInspection(true);
        setActiveCheckIn(false);

        setGetAssignmentData(false);
        setGetOccupancyData(false);
        setGetInspectionData(true);
        setGetCheckInData(false);
        break;
      case "checkin":
        setActiveAssign(false);
        setActiveOccupancy(false);
        setActiveInspection(false);
        setActiveCheckIn(true);

        setGetAssignmentData(false);
        setGetOccupancyData(false);
        setGetInspectionData(false);
        setGetCheckInData(true);
        break;
      default:
        setActiveAssign(true);
        setActiveOccupancy(false);
        setActiveInspection(false);
        setActiveCheckIn(false);
        setGetAssignmentData(true);
        setGetOccupancyData(false);
        setGetInspectionData(false);
        setGetCheckInData(false);
        break;
    }
  };

  return (
    <>
      <ToastMsg showToast={showToast} setShowToast={setShowToast} toastText={toastText} toastBody={toastBody} />

      <Container className={showMenu ? "lg div-main-menu custom-container" : "lg div-main custom-container"}>
        <Tab.Container defaultActiveKey={"bed_assignment"}>
          <Row>
            <Col xs={12} md={3}>
              <Nav
                variant="pills"
                className={showMenu ? "flex-column sticky-top mycase-menu-open-sticky" : "flex-column sticky-top mycase-menu-sticky"}
              >
                <Nav.Item className="mb-2">
                  <PageTitle title={"Shelter"} />
                </Nav.Item>
                <Nav.Item className="d-grid">
                  <Nav.Link
                    eventKey="bed_assignment"
                    className={activeAssign ? "nav-vertical-active" : "nav-vertical"}
                    onClick={() => onNavClick("bed_assignment")}
                    disabled={orgToSave === true ? true : false}
                  >
                    <>
                      <FontAwesomeIcon icon={faArrowsRotate} className={"me-2"} />
                      {toggleMenu ? "Bed Assignment" : "Assignment"}
                    </>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="d-grid">
                  <Nav.Link
                    eventKey="bed_occupancy"
                    className={activeOccupancy ? "nav-vertical-active" : "nav-vertical"}
                    onClick={() => onNavClick("bed_occupancy")}
                    disabled={orgToSave === true ? true : false}
                  >
                    <>
                      <FontAwesomeIcon icon={faUserFriends} className={"me-2"} />
                      {toggleMenu ? "Bed Occupancy" : "Occupancy"}
                    </>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="d-grid">
                  <Nav.Link
                    eventKey="bed_inspection"
                    className={activeInspection ? "nav-vertical-active" : "nav-vertical"}
                    onClick={() => onNavClick("bed_inspection")}
                    disabled={orgToSave === true ? true : false}
                  >
                    <>
                      <FontAwesomeIcon icon={faBullseye} className={"me-2"} />
                      {toggleMenu ? "Bed Inspection" : "Inspection"}
                    </>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="d-grid">
                  <Nav.Link
                    eventKey="checkin"
                    className={activeCheckIn ? "nav-vertical-active" : "nav-vertical"}
                    onClick={() => onNavClick("checkin")}
                    disabled={orgToSave === true ? true : false}
                  >
                    <>
                      <FontAwesomeIcon icon={faClipboardUser} className={"me-2"} />
                      {toggleMenu ? "Check In / Check Out" : "Check In"}
                    </>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Col>
            <Col xs={12} md={9} className="mt-2">
              <Tab.Content>
                <Tab.Pane eventKey="bed_assignment">
                  <BedAssignment
                    setOrgToSave={setOrgToSave}
                    setShowToast={setShowToast}
                    setToastText={setToastText}
                    setToastBody={setToastBody}
                    getData={getAssignmentData}
                    errMsg={errMsg}
                    setErrMsg={setErrMsg}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="bed_occupancy">
                  <BedOccupancy
                    setOrgToSave={setOrgToSave}
                    setShowToast={setShowToast}
                    setToastText={setToastText}
                    setToastBody={setToastBody}
                    getData={getOccupancyData}
                    errMsg={errMsg}
                    setErrMsg={setErrMsg}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="bed_inspection">
                  <BedInspection
                    setOrgToSave={setOrgToSave}
                    setShowToast={setShowToast}
                    setToastText={setToastText}
                    setToastBody={setToastBody}
                    getData={getInspectionData}
                    errMsg={errMsg}
                    setErrMsg={setErrMsg}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="checkin">
                  <CheckIn setShowToast={setShowToast} setToastText={setToastText} setToastBody={setToastBody} getData={getCheckInData} errMsg={errMsg} setErrMsg={setErrMsg} />
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Container>
    </>
  );
};

export default Shelter;
